
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sites/[slug]/[locale]",
      function () {
        return require("private-next-pages/sites/[slug]/[locale]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sites/[slug]/[locale]"])
      });
    }
  